module.exports = __webpack_public_path__ + "img/16581307_L.a3828749.png";